import func_Miscellaneous       from './func_Miscellaneous'

import init_Timeline_Week       from './init_Timeline_Week.js'
import init_Timeline_Month      from './init_Timeline_Month.js'
import init_TimelineValue       from './init_TimelineValue.js'
import init_Skyline_Week        from './init_Skyline_Week.js'
import init_Skyline_Month       from './init_Skyline_Month.js'

export default {
  mixins: [
    func_Miscellaneous,

    init_Timeline_Week,
    init_Timeline_Month,
    init_TimelineValue,
    init_Skyline_Week,
    init_Skyline_Month,
  ],
}
